// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2UGT9","resendInfoText":"OnGoingPaymentBox_resendInfoText__2YIKc"};